// src/components/ui/OrangeButton.js
import styled from 'styled-components';

const OrangeButton = styled.button`
  background-color: #FFF3E6;   /* laranja suave (fundo pastel) */
  color: #FF7A00;              /* laranja principal (texto) */
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.06s ease;

  &:hover {
    background-color: #FFE6CC; /* um tom mais forte no hover */
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 122, 0, 0.35);
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

export default OrangeButton;
